export function applyPdfStyle(clone, doc, originalElement) {
    clone.classList.add('pdf-export');

    clone.querySelector('#actions')?.remove();
    clone.querySelector('#logos')?.remove();

    replaceQrCanvasWithImage(clone, doc, originalElement);

    clone.prepend(buildPdfStyleTag(doc));
}

// QR code: canvas não sobrevive ao cloneNode, precisa converter pra imagem
function replaceQrCanvasWithImage(clone, doc, originalElement) {
    const qr = originalElement.querySelector('canvas');
    const cloneQr = clone.querySelector('canvas');
    if (!qr || !cloneQr) return;

    cloneQr.replaceWith(
        Object.assign(doc.createElement('img'), {
            src: qr.toDataURL('image/png'),
            width: 200,
            height: 200
        })
    );
}

function buildPdfStyleTag(doc) {
	const style = doc.createElement('style');
	style.textContent = `
		.pdf-export {
			width: 800px !important;
			font-family: 'Poppins', sans-serif !important;
			background: #fff !important;
			padding: 32px 40px !important;
			box-sizing: border-box !important;
			color: #000 !important;
		}
    `;
	return style;
}